<template>
	<form action="#" method="post" @submit.prevent="submit">

		<!-- Form Fields -->
		<h2>Account Type</h2>

		<div class="form-field mt-4 mt-md-5">
			<h4 class="mb-md-4">Are you an accredited investor? <Explanation title="Different rules apply for accredited investors and non-natural persons.  An accredited investor is any natural person whose individual net worth, or joint net worth with that person's spouse, at the time of his purchase exceeds $1,000,000, excluding the value of the person’s primary residence, but including any excess liability between the value of the residence and the amount of any obligation(s) thereon; or any natural person who had an individual income in excess of $200,000 in each of the two most recent years or joint income with that person's spouse in excess of $300,000 in each of those years and has a reasonable expectation of reaching the same income level in the current year."/></h4>
			<div class="d-flex flex-wrap">
				<div class="form-check button-checkbox">
					<input type="radio" class="form-check-input" id="accreditedInvestorNo" name="accreditedInvestor" v-model="accreditedInvestor" value="Not Accredited">
					<label for="accreditedInvestorNo" class="form-check-label">No</label>
				</div>
				<div class="form-check button-checkbox ms-2">
					<input type="radio" class="form-check-input" id="accreditedInvestorYes" name="accreditedInvestor" v-model="accreditedInvestor" value="Accredited" checked>
					<label for="accreditedInvestorYes" class="form-check-label">Yes</label>
				</div>
			</div>
		</div>

		<p v-if="accreditedInvestor === 'Not Accredited'" class="small mt-3">By continuing, you certify that you are not investing more than 10% of the greater of your annual income (including the income of your spouse) or your net worth (together with your spouse), excluding the value of your primary residence and any loans secured by the residence (up to the value of the residence).</p>
		<p v-if="accreditedInvestor === 'Accredited'" class="small mt-3">By continuing, you certify that you are an accredited investor.</p>

		<h4 class="mt-4 mt-md-4 pt-2">What account type would you like to open?</h4>
		<div class="form-check-large d-flex flex-wrap mt-3">
			<div class="form-check button-checkbox me-2">
				<input type="radio" class="form-check-input" id="accountTypeIndividual" name="accountType" value="Individual" v-model="accountType">
				<label for="accountTypeIndividual" class="form-check-label">Individual</label>
			</div>
			<div class="form-check button-checkbox">
				<input type="radio" class="form-check-input" id="accountTypeOther" name="accountType" value="Other" v-model="accountType">
				<label for="accountTypeOther" class="form-check-label">Other account</label>
			</div>
		</div>
		<div class="form-field mt-md-4 pt-3" id="otherAccountTypeField" v-if="accountType && accountType === 'Other'">
			<label for="otherAccountType" class="form-label">Other Account Type</label>
			<select class="form-control" name="otherAccountType" id="otherAccountType" v-model="otherAccountType" required>
				<option>Entity</option>
				<option>TIC</option>
				<option>JTWROS</option>
				<option>IRA</option>
				<option>SepIRA</option>
				<option>ROTH</option>
				<option>Joint</option>
			</select>
		</div>
		<p class="text-danger fw-bolder small mt-3" v-if="hasSecondaryParty">We cannot accept investments from {{ otherAccountType }} ownerships at the moment</p>

		<!-- If Entity Type -->
		<div class="form-field mt-md-4 pt-3" id="otherAccountTypeEntityTypeField" v-if="accountType && accountType === 'Other' && otherAccountType && otherAccountType === 'Entity'">
			<label for="otherAccountTypeEntityType" class="form-label">Entity Type</label>
			<select class="form-control" name="otherAccountTypeEntityType" id="otherAccountTypeEntityType" v-model="entity.type" required>
				<option>Revocable Trust</option>
				<option>Irrevocable Trust</option>
				<option>Limited Partnership</option>
				<option>LLC</option>
				<option>Corporation</option>
			</select>
		</div>

		<!-- Relationship -->
		<div class="form-field mt-md-4 pt-3" id="otherAccountRelationField" v-if="accountType && accountType === 'Other' && !hasSecondaryParty">
			<label for="otherAccountRelation" class="form-label">Relationship</label>
			<select class="form-control" name="otherAccountRelation" id="otherAccountRelation" v-model="otherAccountRelation" required>
				<option v-if="!isEntityTrustee">Owner</option>
				<option v-if="!isEntityTrustee">Manager</option>
				<option v-if="!isEntityTrustee">Member</option>
				<option v-if="!isEntityTrustee">Officer</option>
				<option v-if="!isEntityTrustee">Director</option>
				<option v-if="!isEntityTrustee">Spouse</option>
				<option v-if="!isEntityTrustee">Beneficiary</option>
				<option>Trustee</option>
				<option v-if="!isEntityTrustee">Custodian</option>
				<option v-if="!isEntityTrustee">Parentco</option>
				<option v-if="!isEntityTrustee">Subsidiary</option>
				<option v-if="!isEntityTrustee">Other</option>
				<option v-if="!isEntityTrustee">AC Group</option>
				<option v-if="!isEntityTrustee">Advisor</option>
				<option v-if="!isEntityTrustee">Attorney</option>
				<option v-if="!isEntityTrustee">Proxy</option>
			</select>
		</div>

		<!-- Entity Details for Entity -->
		<div class="row" v-if="accountType && accountType === 'Other' && otherAccountType && otherAccountType === 'Entity'">
			<div class="col-xl-6">
				<div class="form-field mt-md-4 pt-3" id="otherAccountTypeEntityNameField">
					<label for="otherAccountTypeEntityName" class="form-label">Entity Name <Explanation title="This is the legal name of the investor in which name the Reiturn Units will be issued and owned. This name must match exactly the state records or other legal formation document."/></label>
					<input type="text" class="form-control" name="otherAccountTypeEntityName" id="otherAccountTypeEntityName" v-model="entity.name" required>
				</div>
			</div>
			<div class="col-xl-6">
				<div class="form-field mt-md-4 pt-3" id="otherAccountTypeEntityEINField">
					<label for="otherAccountTypeEntityEIN" class="form-label">Employer Identification Number</label>
					<input type="text" class="form-control" name="otherAccountTypeEntityEIN" id="otherAccountTypeEntityEIN" v-model="entity.ein" required>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-field mt-md-4 pt-3" id="otherAccountTypeEntityAddress1Field">
					<label for="otherAccountTypeEntityAddress1" class="form-label">Entity Address 1</label>
					<input type="text" class="form-control" name="otherAccountTypeEntityAddress1" id="otherAccountTypeEntityAddress1" v-model="entity.address1" required>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-field mt-md-4 pt-3" id="otherAccountTypeEntityAddress2Field">
					<label for="otherAccountTypeEntityAddress2" class="form-label">Entity Address 2</label>
					<input type="text" class="form-control" name="otherAccountTypeEntityAddress2" id="otherAccountTypeEntityAddress2" v-model="entity.address2">
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-field mt-md-4 pt-3" id="otherAccountTypeEntityCityField">
					<label for="otherAccountTypeEntityCity" class="form-label">Entity City</label>
					<input type="text" class="form-control" name="otherAccountTypeEntityCity" id="otherAccountTypeEntityCity" v-model="entity.city" required>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-field mt-md-4 pt-3" id="otherAccountTypeEntityStateField">
					<label for="otherAccountTypeEntityState" class="form-label">Entity State</label>
					<select class="form-control" name="otherAccountTypeEntityState" id="otherAccountTypeEntityState" v-model="entity.state" required>
						<option selected disabled>Please select</option>
						<option value="AL">Alabama</option>
						<option value="AK">Alaska</option>
						<option value="AZ">Arizona</option>
						<option value="AR">Arkansas</option>
						<option value="CA">California</option>
						<option value="CO">Colorado</option>
						<option value="CT">Connecticut</option>
						<option value="DE">Delaware</option>
						<option value="DC">District Of Columbia</option>
						<option value="FL" disabled>Florida</option>
						<option value="GA">Georgia</option>
						<option value="HI">Hawaii</option>
						<option value="ID">Idaho</option>
						<option value="IL">Illinois</option>
						<option value="IN">Indiana</option>
						<option value="IA">Iowa</option>
						<option value="KS">Kansas</option>
						<option value="KY">Kentucky</option>
						<option value="LA">Louisiana</option>
						<option value="ME">Maine</option>
						<option value="MD">Maryland</option>
						<option value="MA">Massachusetts</option>
						<option value="MI">Michigan</option>
						<option value="MN">Minnesota</option>
						<option value="MS">Mississippi</option>
						<option value="MO">Missouri</option>
						<option value="MT">Montana</option>
						<option value="NE">Nebraska</option>
						<option value="NV">Nevada</option>
						<option value="NH">New Hampshire</option>
						<option value="NJ" disabled>New Jersey</option>
						<option value="NM">New Mexico</option>
						<option value="NY">New York</option>
						<option value="NC">North Carolina</option>
						<option value="ND">North Dakota</option>
						<option value="OH">Ohio</option>
						<option value="OK">Oklahoma</option>
						<option value="OR">Oregon</option>
						<option value="PA">Pennsylvania</option>
						<option value="RI">Rhode Island</option>
						<option value="SC">South Carolina</option>
						<option value="SD">South Dakota</option>
						<option value="TN">Tennessee</option>
						<option value="TX" disabled>Texas</option>
						<option value="UT">Utah</option>
						<option value="VT">Vermont</option>
						<option value="VA">Virginia</option>
						<option value="WA" disabled>Washington</option>
						<option value="WV">West Virginia</option>
						<option value="WI">Wisconsin</option>
						<option value="WY">Wyoming</option>
					</select>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-field mt-md-4 pt-3" id="otherAccountTypeEntityZipField" v-if="accountType && accountType === 'Other' && otherAccountType && otherAccountType === 'Entity'">
					<label for="otherAccountTypeEntityZip" class="form-label">Entity Zip</label>
					<input type="text" class="form-control" name="otherAccountTypeEntityZip" id="otherAccountTypeEntityZip" v-model="entity.zip" required>
				</div>
			</div>
			<div class="col-md-12">
				<div class="form-field mt-md-4 pt-3" id="otherAccountTypeEntityEmailField" v-if="accountType && accountType === 'Other' && otherAccountType && otherAccountType === 'Entity'">
					<label for="otherAccountTypeEntityEmail" class="form-label">Entity Email Address</label>
					<input type="email" class="form-control" name="otherAccountTypeEntityEmail" id="otherAccountTypeEntityEmail" v-model="entity.email" required>
				</div>
				<div class="form-field mt-md-4 pt-3" id="otherAccountTypeEntityPhoneField" v-if="accountType && accountType === 'Other' && otherAccountType && otherAccountType === 'Entity'">
					<label for="otherAccountTypeEntityPhone" class="form-label">Entity Phone</label>
					<input type="text" class="form-control" name="otherAccountTypeEntityPhone" id="otherAccountTypeEntityPhone" v-model="entity.phone">
				</div>
			</div>
		</div>

		<!-- Name & Tax ID for ROTH/IRA/or SepIRA -->
		<div class="row" v-if="accountType && accountType === 'Other' && otherAccountType && (otherAccountType === 'IRA' || otherAccountType === 'SepIRA' || otherAccountType === 'ROTH')">
			<div class="col-xl-6">
				<div class="form-field mt-md-4 pt-3" id="otherAccountTypeNameField">
					<label for="otherAccountTypeName" class="form-label">{{ otherAccountType }} Name <Explanation title="This is the legal name of the investor in which name the Reiturn Units will be issued and owned. This name must match exactly the state records or other legal formation document."/></label>
					<input type="text" class="form-control" name="otherAccountTypeName" id="otherAccountTypeName" v-model="entity.name" required>
				</div>
			</div>
			<div class="col-xl-6">
				<div class="form-field mt-md-4 pt-3" id="otherAccountTypeEINField">
					<label for="otherAccountTypeEIN" class="form-label">{{ otherAccountType }} Identification Number</label>
					<input type="text" class="form-control" name="otherAccountTypeEIN" id="otherAccountTypeEIN" v-model="entity.ein">
				</div>
			</div>
		</div>

		<!-- Secondary Party Details for JTWROS/Joint/or TIC -->
<!--		<div class="row" v-if="hasSecondaryParty">-->
		<div class="row" v-if="false">
			<div class="col-md-12">
				<h4 class="mt-4 mt-md-5 pt-2">Secondary Party Personal Information</h4>
				<p>Please enter the personal details of the second party of your {{ otherAccountType }} {{ (otherAccountType === 'Joint' ? 'ownership' : '') }}</p>
			</div>
			<div class="col-md-6 mt-3 pt-3">
				<div class="form-field">
					<label for="secondaryPartyFirstName" class="form-label">First Name</label>
					<input type="text" class="form-control" name="secondaryPartyFirstName" id="secondaryPartyFirstName" v-model="secondary.firstName" placeholder="Enter first name" required>
				</div>
			</div>
			<div class="col-md-6 mt-3 pt-3">
				<div class="form-field">
					<label for="secondaryPartyLastName" class="form-label">Last Name</label>
					<input type="text" class="form-control" name="secondaryPartyLastName" id="secondaryPartyLastName" v-model="secondary.lastName" placeholder="Enter last name" required>
				</div>
			</div>
			<div class="col-md-6 mt-3 pt-3">
				<div class="form-field">
					<label for="secondaryPartySsn" class="form-label">Social Security Number</label>
					<input type="text" class="form-control" name="secondaryPartySsn" id="secondaryPartySsn" placeholder="Enter 9 digit SSN" v-model="secondary.ssn" required>
					<p class="text-danger fw-bolder mt-2 small" v-if="secondarySsnError">Please enter valid Social Security Number.</p>
				</div>
			</div>
			<div class="col-md-6 mt-3 pt-3">
				<div class="form-field">
					<label for="secondaryPartyBirthday" class="form-label">Date of Birth</label>
					<input type="date" class="form-control" name="secondaryPartyBirthday" id="secondaryPartyBirthday" v-model="secondary.birthday" required>
				</div>
			</div>
			<div class="col-md-12 mt-3 pt-3">
				<div class="form-field">
					<label for="secondaryPartyAddress1" class="form-label">Address Line 1</label>
					<input type="text" class="form-control" name="secondaryPartyAddress1" id="secondaryPartyAddress1" placeholder="Required" required v-model="secondary.address1">
				</div>
			</div>
			<div class="col-md-12 mt-3 pt-3">
				<div class="form-field">
					<label for="secondaryPartyAddress2" class="form-label">Address Line 2</label>
					<input type="text" class="form-control" name="secondaryPartyAddress2" id="secondaryPartyAddress2" placeholder="Enter if applicable" v-model="secondary.address2">
				</div>
			</div>
			<div class="col-md-6 mt-3 pt-3">
				<div class="form-field">
					<label for="secondaryPartyCity" class="form-label">City</label>
					<input type="text" class="form-control" name="secondaryPartyCity" id="secondaryPartyCity" placeholder="Enter city name" required v-model="secondary.city">
				</div>
			</div>
			<div class="col-md-6 mt-3 pt-3">
				<div class="form-field">
					<label for="secondaryPartyState" class="form-label">State</label>
					<select class="form-control" name="secondaryPartyState" id="secondaryPartyState" required v-model="secondary.state">
						<option disabled selected value="">Select state</option>
						<option value="AL">Alabama</option>
						<option value="AK">Alaska</option>
						<option value="AZ">Arizona</option>
						<option value="AR">Arkansas</option>
						<option value="CA">California</option>
						<option value="CO">Colorado</option>
						<option value="CT">Connecticut</option>
						<option value="DE">Delaware</option>
						<option value="DC">District Of Columbia</option>
						<option value="FL">Florida</option>
						<option value="GA">Georgia</option>
						<option value="HI">Hawaii</option>
						<option value="ID">Idaho</option>
						<option value="IL">Illinois</option>
						<option value="IN">Indiana</option>
						<option value="IA">Iowa</option>
						<option value="KS">Kansas</option>
						<option value="KY">Kentucky</option>
						<option value="LA">Louisiana</option>
						<option value="ME">Maine</option>
						<option value="MD">Maryland</option>
						<option value="MA">Massachusetts</option>
						<option value="MI">Michigan</option>
						<option value="MN">Minnesota</option>
						<option value="MS">Mississippi</option>
						<option value="MO">Missouri</option>
						<option value="MT">Montana</option>
						<option value="NE">Nebraska</option>
						<option value="NV">Nevada</option>
						<option value="NH">New Hampshire</option>
						<option value="NJ">New Jersey</option>
						<option value="NM">New Mexico</option>
						<option value="NY">New York</option>
						<option value="NC">North Carolina</option>
						<option value="ND">North Dakota</option>
						<option value="OH">Ohio</option>
						<option value="OK">Oklahoma</option>
						<option value="OR">Oregon</option>
						<option value="PA">Pennsylvania</option>
						<option value="RI">Rhode Island</option>
						<option value="SC">South Carolina</option>
						<option value="SD">South Dakota</option>
						<option value="TN">Tennessee</option>
						<option value="TX">Texas</option>
						<option value="UT">Utah</option>
						<option value="VT">Vermont</option>
						<option value="VA">Virginia</option>
						<option value="WA">Washington</option>
						<option value="WV">West Virginia</option>
						<option value="WI">Wisconsin</option>
						<option value="WY">Wyoming</option>
					</select>
				</div>
			</div>
			<div class="col-md-12 mt-3" v-if="!isValidState">
				<p class="text-danger fw-bolder mt-2 small">We cannot accept investments from residents of Texas, Florida, Washington, and New Jersey at this time; however we expect to be able to accept investments in these states soon.</p>
				<p class="text-danger fw-bolder mt-2 small">You may provide your contact info so that we may notify you when investments in these states are possible.</p>
				<a href="https://www.reiturn.com/reserve-your-investment" target="_blank" class="btn btn-secondary mt-3">Get Notification</a>
			</div>
			<div class="col-md-6 mt-3 pt-3">
				<div class="form-field">
					<label for="secondaryPartyZip" class="form-label">ZIP Code</label>
					<input type="text" class="form-control" name="secondaryPartyZip" id="secondaryPartyZip" placeholder="Enter zip code" required v-model="secondary.zip">
				</div>
			</div>
			<div class="col-md-6 mt-3 pt-3">
				<div class="form-field">
					<label for="secondaryPartyRelation" class="form-label">Relationship</label>
					<select class="form-control" name="secondaryPartyRelation" id="secondaryPartyRelation" v-model="secondary.relation" required>
						<option>Owner</option>
						<option>Manager</option>
						<option>Member</option>
						<option>Officer</option>
						<option>Director</option>
						<option>Spouse</option>
						<option>Beneficiary</option>
						<option>Trustee</option>
						<option>Custodian</option>
						<option>Parentco</option>
						<option>Subsidiary</option>
						<option>Other</option>
						<option>AC Group</option>
						<option>Advisor</option>
						<option>Attorney</option>
						<option>Proxy</option>
					</select>
				</div>
			</div>
			<div class="col-md-12 mt-3 pt-3">
				<div class="bg-light p-3 rounded small"><strong class="d-block">Does your {{ otherAccountType }} have more than 2 owners?</strong> Contact us at <a href="mailto:InvestorRelations@Reiturn.com" class="text-brand fw-bolder">InvestorRelations@Reiturn.com</a> to connect all of them to your account.</div>
			</div>
		</div>

		<!-- Form Navigation -->
		<div class="d-flex flex-column-reverse flex-md-row justify-content-md-end pt-4 pt-md-5">
<!--			<button class="btn btn-outline-dark me-md-2 mt-2 mt-md-0" type="button" @click.prevent="back">Back</button>-->
			<button class="btn btn-primary btn-wide" type="submit" :disabled="hasSecondaryParty">Continue</button>
		</div>
	</form>
</template>

<script>

import Explanation from "@/components/widgets/Explanation";
export default {
    name: "BasicForm",
    components: {Explanation},
    beforeMount() {

        // Verify the previous step is completed
        if(!this.$store.getters.personal.completed) {
            this.$router.replace("/personal");
        }

        // Verify if the current step is finished
        if(this.$store.getters.basic.finished) {
            this.$router.replace("/details/contact-tax-reporting");
        }
    },
    data() {
        return {
            accreditedInvestor: this.$store.getters.basic.accreditedInvestor,
            country: this.$store.getters.basic.country,
            accountType: this.$store.getters.basic.accountType,
            otherAccountType: this.$store.getters.basic.otherAccountType,
            otherAccountRelation: this.$store.getters.basic.otherAccountRelation,
            entity: this.$store.getters.basic.entity,
            secondary: this.$store.getters.basic.secondary,
			showErrors: false,
            secondarySsnError: false,
        }
    },
    methods: {
        back() {
            this.$store.commit("updateBasic", {
                accreditedInvestor: this.accreditedInvestor,
                country: this.country,
                accountType: this.accountType,
                otherAccountType: this.otherAccountType,
                otherAccountRelation: this.otherAccountRelation,
                entity: this.entity,
                secondary: this.secondary,
            });
            this.$router.back();
        },
        submit() {
            if(!this.checkCountry()) {
                this.showErrors = true;
                return false;
            }
            if(!this.checkSSN()) {
                this.secondarySsnError = true;
                return false;
            }
            this.$store.commit("updateBasic", {
                accreditedInvestor: this.accreditedInvestor,
                country: this.country,
                accountType: this.accountType,
                otherAccountType: this.otherAccountType,
                otherAccountRelation: this.otherAccountRelation,
                entity: this.entity,
                secondary: this.secondary,
            });
            this.$router.push("/details/contact-tax-reporting");
        },
		checkCountry() {
            if(!this.country) return false;
            return this.country === 'United States';
		},
        checkSSN() {
            if(!this.hasSecondaryParty) return true;
            if(!this.secondary.ssn) return false;
            if(/^[0-9]{9}$/.test(this.secondary.ssn)) return true;
            if(/^[0-9]{3}-[0-9]{2}-[0-9]{4}$/.test(this.secondary.ssn)) return true;
            return false;
        },
    },
    computed: {
        isValidState() {
            if(!this.secondary.state) return true;
            return ["TX", "FL", "WA", "NJ"].indexOf(this.secondary.state) < 0;
        },
		hasSecondaryParty() {
            return this.accountType && this.accountType === 'Other' && this.otherAccountType && (this.otherAccountType === 'TIC' || this.otherAccountType === 'JTWROS' || this.otherAccountType === 'Joint');
		},
        isEntityTrustee() {
            return this.otherAccountType === 'Entity' && (this.entity.type === 'Revocable Trust' || this.entity.type === 'Irrevocable Trust')
		},
    },
	watch: {
        'entity.type'(newValue) {
            if(newValue === 'Revocable Trust' || newValue === 'Irrevocable Trust') {
                this.otherAccountRelation = 'Trustee';
			}
		}
	},
}
</script>